import { Moment } from "moment";
import styles from './MonthlyReportShareholding.module.scss';
import { directorSelectOptionValidation } from "../../../Underwriting/Director/directorHelper";
import { Field, useField, useForm } from "react-final-form";
import MeritoRadioButton from "../../../Finance/components/RadioButton/MeritoRadioButton";
import AddDataSection from "../../components/AddDataSection/AddDataSection";
import { useState } from "react";
import ShareholderGrid from "../../../Underwriting/CompanyDetails/Shareholder/ShareholderGrid";
import { Modal } from "reactstrap";
import { FieldMode } from "../../../../interfaces/interfaces";
import InvestmentsGrid from "../../../Underwriting/Investments/InvestmentsGrid";

type Props = {
  monthYear: Moment
}



const MonthlyReportShareholding = ({ monthYear }: Props) => {

  const [isOpenShareholder, setIsOpenShareholder] = useState(false);
  const [isInvestmentsOpen, setIsInvestmentsOpen] = useState(false);
  const { input: { value: raisedEquity } } = useField(`raisedEquity.${monthYear.format("MM-YYYY")}`, { subscription: { value: true } });
  const [fieldMode, setFieldMode] = useState(FieldMode.view);
  const { change } = useForm();


  return (
    <div id="shareholderDetails" className={styles.fieldsContainer}>
      <Field name={`raisedEquity.${monthYear.format("MM-YYYY")}`} validate={(values) => directorSelectOptionValidation(values)}>
        {(props) => (
          <MeritoRadioButton
            {...props.input}
            label={`Did you raise any equity in ${monthYear.format("MMM")}?`}
            radioLabels={[
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ]}
            name={props.input.name}
            value={props.input.value}
            onChange={props.input.onChange}
            error={props.meta.error}
            touched={props.meta.touched}
            isLabelBold={true}
            size="md2"
          />
        )}
      </Field>



      {raisedEquity == "yes" ?
        <div className={styles.fieldContainer}>
          <div className={styles.sectionsRoot}>
            <div className={styles.sectionContainer}>
              <AddDataSection
                sectionTitle="Investments"
                btnText="Update"
                onClickHandler={() => {
                  // console.log("Update Shareholding Pattern");
                  setFieldMode(FieldMode.edit);
                  setIsInvestmentsOpen(true)
                }}
                isMultipleSections={true}
              />
            </div>
            <AddDataSection
              sectionTitle="Shareholding Pattern"
              btnText="Update"
              onClickHandler={() => {
                // console.log("Update Shareholding Pattern");
                setFieldMode(FieldMode.edit);
                setIsOpenShareholder(true)
              }}
              isMultipleSections={true}
            />
          </div>
        </div>
        :
        <>
          <div className={styles.viewPreviousHolding} onClick={() => {
            setFieldMode(FieldMode.view);
            setIsInvestmentsOpen(true)
          }}>
            View Previous Investments
          </div>
          <div className={styles.viewPreviousHolding} onClick={() => {
            setFieldMode(FieldMode.view);
            setIsOpenShareholder(true)
          }}>
            View Previous Shareholding
          </div>
        </>
      }
      <Field name='shareholderDetails'>
        {(props) => {
          return (
            <>
              {props?.meta?.error && props?.meta?.touched ? <div className={styles.errorText}>
                {props?.meta?.error}
              </div> : null}
            </>
          )
        }}
      </Field>


      <Modal
        isOpen={isOpenShareholder}
        toggle={() => {
          setIsOpenShareholder(!isOpenShareholder)
        }}
        size='lg'
        fullscreen={true}
        keyboard={false}
      >
        <ShareholderGrid fieldMode={fieldMode} setFieldMode={setFieldMode} onChangeDetected={() => {
          change(`raisedEquity.${monthYear.format("MM-YYYY")}`, "yes");
        }} fieldName='shareholderDetails' setIsOpen={setIsOpenShareholder} isOpen={isOpenShareholder} />
      </Modal>
      <Modal
        isOpen={isInvestmentsOpen}
        toggle={() => {
          setIsInvestmentsOpen(prop => !prop)
        }}
        size='lg'
        fullscreen={true}
        keyboard={false}
      >
        <InvestmentsGrid fieldMode={fieldMode} setFieldMode={setFieldMode} onChangeDetected={() => {
          change(`raisedEquity.${monthYear.format("MM-YYYY")}`, "yes");
        }} fieldName='investmentRounds' setIsOpen={setIsInvestmentsOpen} isOpen={isInvestmentsOpen} />
      </Modal>
    </div >
  );
}

export default MonthlyReportShareholding;